import { useMemo } from "react";
import { useVehiclesSocketStore } from "../../../store/admin/vehiclesSocketStore";
import { resolveShipmentUnit, type ShipmentUnit } from "../utils/shipmentUnit";

export type { ShipmentUnit };

export function useShipmentUnit(deviceId: string | null | undefined): ShipmentUnit | null {
  const vehicles = useVehiclesSocketStore((state) => state.vehicles);

  return useMemo(() => resolveShipmentUnit(vehicles, deviceId), [vehicles, deviceId]);
}
